/*
* Show Spacing Y dropdown based on tab route or v-scored
*/
import React from 'react';
import SelectComponent from 'shared/components/SelectComponent';
import {
  arraySpacingY as tooltipVScore,
  arraySpacingXTabRouted as tooltipTabRouted,
} from 'shared/data/tooltips';
import { spacingTabRouted, spacingVScored } from 'shared/data/selectOptions';

const ArraySpacingYTV = (props) => {
  const {
    parameters,
    label,
    required,
    name,
    onChangeParameter,
    groupName,
  } = props;
  const selectedName = parameters.tab_rout === '1' ? 'array_spacing_y_tab_rout' : 'array_spacing_y_vscore';
  const onChange = e => onChangeParameter(selectedName, e.target.value);

  const spacingYTabRouted = (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={spacingTabRouted}
      tooltip={tooltipTabRouted}
      selected={parameters[selectedName] || ''}
      groupName={groupName} />);
  const spacingYVscore = (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={spacingVScored}
      tooltip={tooltipVScore}
      selected={parameters[selectedName] || ''}
      groupName={groupName} />);

  const Component = parameters.tab_rout === '1' ? spacingYTabRouted : spacingYVscore;

  return (
    <div>{Component}</div>
  );
};

ArraySpacingYTV.defaultProps = {
  label: 'Spacing in Y',
  name: 'array_spacing_y',
  required: true,
  onChange: null,
  groupName: null,
};

export default ArraySpacingYTV;
